import { apiV2 } from '../api'
import { CategoryReponse } from './dtos'

export const getCategories = async (category: string) => {
  try {
    if (!category) return

    const { data } = await apiV2.get<CategoryReponse>(
      `/canais/categorias/${category}`
    )

    return data
  } catch {
    return undefined
  }
}
